import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=4a1e5bc5"
import script from "./MenuPrincipal.vue?vue&type=script&lang=ts"
export * from "./MenuPrincipal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports